export function resolveAnswerType(variable) {
  if (!variable) return 'text'
  const { type, matrixType } = variable

  if (type === 'yes_no') return 'boolean'
  if (type === 'choice') return 'setMember'
  if (type === 'scale') return 'setMember'
  if (type === 'number') return 'scalar'
  if (type === 'file') return 'fileUpload'
  if (type === 'text') return 'text'

  if (matrixType === 'ordinal') return 'setMember'
  if (matrixType === 'numeric' || matrixType === 'duration' || matrixType === 'datetime') return 'scalar'
  if (matrixType === 'categorical-bounded') return 'setMember'
  if (matrixType === 'categorical-freetext-unmapped' || matrixType === 'categorical-freetext-mapped') return 'text'
  if (matrixType === 'identifier') return 'text'
  if (matrixType === 'file-upload') return 'fileUpload'

  return 'text'
}

export function isOrdinal(variable) {
  if (!variable) return false
  return variable.type === 'scale' || variable.matrixType === 'ordinal'
}

export const ANSWER_TYPE_META = {
  boolean:   { label: 'Boolean',    bg: '#EBF4FF', fg: '#2B6BBF' },
  setMember: { label: 'Set member', bg: '#E8F5E9', fg: '#2E7D32' },
  scalar:    { label: 'Scalar',     bg: '#FFF9E6', fg: '#7A6A3A' },
  fileUpload:{ label: 'File upload', bg: '#EEF2F6', fg: '#5F6368' },
  text:      { label: 'Text',       bg: '#FFEBEE', fg: '#C62828' },
}

// The same answers extractValues returns, each still attached to the person who
// gave it. A chart counts values; clicking one of its bars has to name names, so
// both come from one filter rule rather than two that could drift apart.
export function extractAnswerRows(responses, varName) {
  if (!Array.isArray(responses)) return []
  return responses
    .filter(row => row?.[varName] != null && row[varName] !== '')
    .map(row => ({
      value: row[varName],
      recipientId: row.recipient_id ?? '',
      sessionId: row.session_id ?? '',
    }))
}

export function extractValues(responses, varName) {
  return extractAnswerRows(responses, varName).map(row => row.value)
}
